export function changeStrings(str) {
  var s = "";
  s = str;
  console.log("low----->" + s.toLowerCase());
  return s.toLowerCase();
}

/**
 * 将请求参数中含有的分页信息转化成url参数
 * @param {*} data 请求体
 * @returns string '?pageNo=1&pageSize=15'
 */
export function pageInfoToUrl(data) {
  if (!data) return ''
  const infoKeys = ["pageNo", "pageSize"];

  let urlParam = "";
  infoKeys.forEach((key) => {
    if (key in data) {
      urlParam += `${key}=${data[key]}&`;
      delete data[key];
    }
  });

  if (urlParam) {
    urlParam = `?${urlParam.substring(0, urlParam.length - 1)}`;
  }
  return urlParam
}

/**
 * 将对象参数转换成url参数
 * @param {Object} data 
 * @returns baidu.com?a=2&b=3
 */
export function dataToUrlParam(url, data) {
  if (!data) return url

  const keys = Object.keys(data)
  if (keys.length === 0) {
    return url
  }

  let params = ''
  keys.forEach(key => {
    params += `${key}=${data[key]}&`
  })

  if (params.length > 0) {
    params = params.substring(0, params.length - 1)
    url += `?${params}`
  }

  return url
}


// WEBPACK FOOTER //
// src/util/stringsUtil.js